<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SD" @change="campaignSelectChange($event)"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SD"></ad-group-select>
        <gj-select
            v-model="status"
            :options="AdProductTargetEnum.SD.statusOption"
            placeholder="状态"
        ></gj-select>
        <gj-lazy-input
            v-model="keyword"
            placeholder="类别/ASIN"
        ></gj-lazy-input>
        <gj-date-picker
            v-model="date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSdCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdTargeting/export" :download-params="globalParams"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add"
      >新增商品投放</gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdProductTargetEnum.SD.status.ARCHIVE)"
          @click="adjustBid">
        调整竞价
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductTargetEnum.SD.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdProductTargetEnum.SD.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSdCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdProductTargetEnum.SD.status.ENABLE, AdProductTargetEnum.SD.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdTargeting/export" :download-params="globalParams"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSdCampaigns:addOrUpdate')"
          size="has-picture"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          show-summary
          :selectable="notEqSelectable('state', AdProductTargetEnum.SD.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSdCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdProductTargetEnum.SD.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdProductTargetEnum.SD.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdProductTargetEnum.SD.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:belongGroup="{row}">
          <app-sd-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sd-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:bid="{row}">
          {{row.bid | defaultShow(row.currencySymbol)}}
        </template>
        <template v-slot:productTargetName="{row}">
          <template v-if="row.resolvedExpressionList && row.resolvedExpressionList.length > 0">
            <gj-tooltip
                v-for="(item, i) in row.resolvedExpressionList"
                :key="i"
                :text-line="1">
              <template #content> {{ item.type }}={{ item.value }} </template>
              <template v-if="item.type === 'exactProduct'">商品浏览</template>
              <template v-else-if="item.type === 'similarProduct'">类似商品浏览</template>
              <template v-else-if="item.type === 'asinSameAs'">
                asinSameAs=<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
              </template>
              <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                {{item.type}}={{item.value}}
              </template>
              <template v-else>-</template>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin, currencySymbolMixin,
    adAdvancedFilteringMixin,
    inCampaignMixin, inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {isMeaningfulMixin, queryMixin, selectionMixin} from "../../../../../../minxins";
  import AppAdjustBidModal from "../../../common/modal/adjust/adjust-bid-modal";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import {AdProductTargetEnum} from "../../../common/enum";
  import AppAddSdAdProductTarget from "../../common/modal/add/product-target/add-ad-product-target";
  import AppSdAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
  import {subDays} from 'date-fns';
  import {isMeaningful, isMeaningless, defaultVal} from "../../../../../../utils/common";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {adStore} from "../../../common/store";
  import {getSdAdProductTargetPage, updateSdAdProductTarget, queryAsinInfo} from "../../../../../../api/ad";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import {LOG_OP_TYPE} from "../../../common/options";
  import { getAsinInfo } from '@/views/modules/ad/config'

  export default {
    name: "app-sd-ad-product-target",
    components: {AppSdAdRouteLink, AdCampaignSelect, AdGroupSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, inGroupMixin, tableNameMixin, selectionMixin,
      adBaseDataMixin, queryMixin, currencySymbolMixin, initDateMixin,
      isMeaningfulMixin, adDefaultSortMixin,
      adAdvancedFilteringMixin
    ],
    created() {
      this.columns = [
        adFields.status,
        adFields.picture,
        adFields.productTargetName,
        {...adFields.servingStatus, options: AdProductTargetEnum.SD.servingStatusOption},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // adFields.creationDate,
        // adFields.suggestBid,
        adFields.bid,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        adFields.acos,
        adFields.roas,
        adFields.op,
      ].filter(e => e!== null);
    },
    data() {
      return {
        helpName:'sdadmanager',
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        AdProductTargetEnum: AdProductTargetEnum,
        // filter
        status: AdProductTargetEnum.SD.status.ENABLE_PAUSE,
        keyword: null,
        extendSearch: null,
        date: this.initDate || [subDays(new Date(), 6), new Date()]
      }
    },
    methods: {
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SD', afferent)
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          status: AdProductTargetEnum.SD.status.ENABLE_PAUSE,
          keyword: null,
          extendSearch: null,
          date: [subDays(new Date(), 6), new Date()]
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            campaignIds: this.campaignIds,
            groupIds: this.groupIds,
            marketId: this.marketId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            extendSearch: this.extendSearch,
            state: defaultVal(this.status, null),
            expressionValue: this.keyword,
            startDate: convertToDate(this.date[0]),
            endDate: convertToDate(this.date[1])
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSdAdProductTargetPage(params)
          .then(async (data) => {
            if (isMeaningful(data)) {
              const tableData = this.currencySymbolMixin(data.records, adStore.SD.currencySymbol);
              tableData.forEach(e => {
                try {
                  e.resolvedExpressionList = JSON.parse(e.expression);
                } catch (e) {
                  e.resolvedExpressionList = [];
                }
              });
              this.tableData = tableData;
              getAsinInfo('expressionValue', this.tableData[0].marketId, data.countryCode, this.tableData, 'imageUrl');
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      add() {
        const modal = this.$gjCreate(AppAddSdAdProductTarget, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SD.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdProductTarget({
                marketId: this.marketId,
                targetIds: this.selectedRows.map(e => e.targetId),
                adjustmentType: modal.form.bid.key,
                adjustmentValue: modal.form.bid.value
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: `已选择 ${rows.length} 个商品投放，确认启用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              updateSdAdProductTarget({
                marketId: this.marketId,
                targetIds: rows.map(e => e.targetId),
                state: AdProductTargetEnum.SD.status.ENABLE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: `已选择 ${rows.length} 个商品投放，确认停用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdProductTarget({
                marketId: this.marketId,
                targetIds: rows.map(e => e.targetId),
                state: AdProductTargetEnum.SD.status.PAUSE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdProductTarget({
                marketId: this.marketId,
                targetIds: this.selectedRows.map(e => e.targetId),
                state: AdProductTargetEnum.SD.status.ARCHIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            groupId: this.groupId,
            // name: isMeaningful(row) ? row.asin : '',
            opId: isMeaningful(row) ? row.targetId : null,
            adType: LOG_OP_TYPE.SD,
            object: LOG_OP_TYPE.SD.PRODUCT_TARGET
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
